import {configureStore} from '@reduxjs/toolkit';
import signUp from './reducers/signUp';
import shared from './reducers/shared';
import authorization from './reducers/authorization';
import general from './reducers/general';

const store = configureStore({
    reducer: {
        shared,
        signUp,
        authorization,
        general
    },
    devTools: process.env.NODE_ENV !== 'production'
});

type AppState = ReturnType<typeof store.getState>;
type AppDispatch = typeof store.dispatch;

export type {AppState, AppDispatch};
export default store;
